import { stateMixin } from '@/store/mixins/data-grid/state'
import { gettersMixin } from '@/store/mixins/data-grid/getters'
import { mutationsMixin } from '@/store/mixins/data-grid/mutations'
import { actionsMixin } from '@/store/mixins/data-grid/actions'

export default {
  stateMixin,
  gettersMixin,
  mutationsMixin,
  actionsMixin
}
